import useSession from '../../hooks/useSession';
import { Link, useLocation } from 'react-router-dom'
import { useContext } from 'react';
import { UserContext } from '../../context/UserContext';

const NavBar = () => {
  const [session, setSession, removeSession] = useSession()
  const { removeUser } = useContext(UserContext)
  const { user, getCustomItem } = useContext(UserContext)
  const location = useLocation();

  const checkMagicLink = () => {
    const magicLink = getCustomItem('bunny.MagicLink')
    return magicLink ? false : true
  }

  return (
    <nav className="w-full h-20 bg-[#D9D9D9] px-10 flex items-center text-base font-normal fixed top-0 z-20">
      <ul className='w-full flex justify-between'>
        {session ? (
          <>
            <div className='flex gap-8'>
              {user && user.position == 'am' ? <li>
                <Link to="/widget#dashboard" reloadDocument>
                  Project dashboard
                </Link>
              </li> : ''}
            </div>
            <div className='flex gap-8'>
            {user && user.position == 'am' ? <li>
              <Link to="/magic-link">
                Invite to new project
              </Link>
            </li> : ''}
            {checkMagicLink() ? <div className='cursor-pointer' onClick={() => {removeSession(); removeUser();}}>Log out</div> : ''}
            </div>
          </>
        ) :
          (<>
            <div className='w-full flex justify-end gap-8'>
              {location.pathname != '/guest' ? <li>
                <Link to="/guest">
                  Start as guest
                </Link>
              </li> :
              <li>
                <Link to="/login">
                  Start as account manager
                </Link>
              </li>}
            </div>
          </>)
        }
      </ul>
    </nav>
  )
}

export default NavBar